<sf-horizontal-menu variant="pills" layout="justified">
    <sf-horizontal-menu-item>
        <a sfNavLink [routerLink]="['home']" routerLinkActive="active">Home</a>
    </sf-horizontal-menu-item>
    <sf-horizontal-menu-item>
        <a sfNavLink [routerLink]="['insights']" routerLinkActive="active">Insights</a>
    </sf-horizontal-menu-item>
</sf-horizontal-menu>

<router-outlet></router-outlet>
